import { Box, Container, styled } from '@mui/material';

export const ButtonContainer = styled(Container)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingBottom: '0'
}));

export const Wrapper = styled(Box)(({ theme }) => ({
  borderBottom: '1px dashed lightgrey',
  paddingTop: 12,
  marginLeft: -18,
  marginRight: -18,
  [theme.breakpoints.up('sm')]: {
    marginLeft: -32,
    marginRight: -32
  }
}));

export const ContentBox = styled(Box)(({ theme }) => ({
  marginLeft: 18,
  marginRight: 18,
  [theme.breakpoints.up('sm')]: {
    marginLeft: 32,
    marginRight: 32
  }
}));
